<terra-main-nav />
<ng-template #loading>
  <terra-loader class="loader" />
</ng-template>
<ng-container *ngIf="userDetails$ | async as model; else loading">
  <!-- <div class="header-wrapper"> -->
    <div class="container my-account-header" fxLayoutAlign="space-between center">
      <div>
        <h1>My account</h1>
        <h2>Covercy ID: {{ model.clientIdentifier }}</h2>
      </div>
      <!-- <button type="button" class="close-button" mat-icon-button aria-label="Close" [routerLink]="paths.DASHBOARD">
        <mat-icon class="return-link notranslate">clear</mat-icon>
      </button> -->
    </div>
  <!-- </div> -->
  <div class="my-account-content">
    <mat-accordion displayMode="flat" class="container">
      <!-- Support PIN -->
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper">
              <mat-icon color="accent" class="circle-icon notranslate">call_outline</mat-icon>
            </div>
            <div>
              <div class="header-text">Support PIN</div>
              <div class="header-text-sub lo_sensitive">{{ supportPin$ | async }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <terra-support-pin [supportPin]="supportPin$ | async" />
        </ng-template>
      </mat-expansion-panel>

      <!-- email -->
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper">
              <mat-icon color="accent" class="circle-icon notranslate">mail_outline</mat-icon>
            </div>
            <div>
              <div class="header-text">Change email</div>
              <div class="header-text-sub lo_sensitive">{{ model?.email }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <terra-change-email [model]="model" />
        </ng-template>
      </mat-expansion-panel>

      <!-- two factor authentication -->
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper">
              <mat-icon color="accent" class="circle-icon notranslate">mobile_friendly_outline</mat-icon>
            </div>
            <div>
              <div class="header-text">Account security</div>
              <div class="header-text-sub">Two-factor authentication {{ model.isTwoFactorAuthenticationEnabled ? 'enabled' : 'disabled' }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <terra-two-factor-authentication [model]="model" />
        </ng-template>
      </mat-expansion-panel>

      <!-- Change password -->
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper"><mat-icon color="accent" class="circle-icon notranslate">lock_outline</mat-icon></div>
            <div>
              <div class="header-text">Change password</div>
              <div class="header-text-sub">*********</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <terra-change-password [model]="model" />
        </ng-template>
      </mat-expansion-panel>

      <!-- personal details -->
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper">
              <mat-icon color="accent" class="circle-icon notranslate">person_outline</mat-icon>
            </div>
            <div>
              <div class="header-text">Personal details</div>
              <div class="header-text-sub lo_sensitive">{{ model?.firstName }} {{ model?.lastName }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <terra-personal-details [model]="model" />
        </ng-template>

      </mat-expansion-panel>

      <!-- Company Profile -->
      <mat-expansion-panel terraCheckPermissions [minimumPermissionLevel]="PermissionLevel.Admin" [noPermissionAction]="NoPermissionAction.Hide" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="icon-wrapper">
              <mat-icon color="accent" svgIcon="business_center_outline" class="circle-icon notranslate" />
            </div>
            <div>
              <div class="header-text">Company profile</div>
              <div class="header-text-sub lo_sensitive">{{ model?.organizationDetails.name }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <terra-company-profile [model]="model" />
        </ng-template>

      </mat-expansion-panel>
        <!-- Data Exports -->
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="icon-wrapper">
                <mat-icon color="accent" class="circle-icon notranslate">launch</mat-icon>
              </div>
              <div>
                <div class="header-text">Data</div>
                <div class="header-text-sub lo_sensitive">Export your data</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <terra-data />
          </ng-template>
          
        </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-container>
